import React from 'react';
import { Box, costFormater, Inscription } from '@common-fe/common-fe';
import { isNumber } from 'lodash';

const N_A: string = 'N/A';

interface TriggerAmountProps {
  triggerName?: string;
  triggerAmount?: number;
}

export const TriggerAmount: React.FC<TriggerAmountProps> = ({ triggerName, triggerAmount }) => {
  return (
    <Box
      direction="row"
      pad={{ vertical: 'm', horizontal: '20px' }}
      round="container2Round"
      background="canvas"
      border={{ color: 'border2', size: '1px' }}
      height="52px"
    >
      <Box width="50%">
        <Inscription color="textBody" lineHeight="20px">
          {triggerName || N_A}
        </Inscription>
      </Box>
      <Box width="50%">
        <Inscription color="textBody" lineHeight="20px">
          {isNumber(triggerAmount) ? costFormater(triggerAmount, true) : N_A}
        </Inscription>
      </Box>
    </Box>
  );
};
